var _rect, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0, _path1, _path10;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFetImg19(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 105,
    height: 72,
    viewBox: "0 0 105 72",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.910156,
    y: 0.25,
    width: 104,
    height: 71.5,
    rx: 9.3565,
    fill: "#FFEDD1"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M62.0081 39.6091L53.3447 35.3484L52.9997 35.5592L52.7372 35.3101L43.9876 39.6072L43.6426 40.1592L43.8534 40.6441L52.2235 44.7554H53.776L62.1442 40.6441L62.355 40.1592L62.0081 39.6091Z",
    fill: "#95001A"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M43.6429 40.1592L52.9981 44.7573V45.1387L46.9357 48.1191H46.1575L43.6429 46.8656L43.2979 46.3558V40.7112L43.6429 40.1592Z",
    fill: "#40004D"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M62.3534 40.1592L53.002 44.7573V45.1387L59.0644 48.1191H59.8425L62.3591 46.8656L62.7041 46.3558V40.7112L62.3534 40.1592Z",
    fill: "#520033"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M62.3587 31.0205L62.0137 31.2313V39.6091L62.3548 40.1611L62.7037 40.7112L68.3578 43.4903H69.136L70.2496 42.9345L62.3587 31.0205Z",
    fill: "#FFA80A"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M43.6409 31.0205L43.9859 31.2313V39.6091L43.6409 40.1611L43.2959 40.7112L37.6418 43.4903H36.8655L35.75 42.9326L43.6409 31.0205Z",
    fill: "#FF3417"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M43.6407 46.8656L36.8652 43.4885L43.6407 40.1611V46.8656Z",
    fill: "#6D0044"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M52.9978 51.5251L59.8365 48.1192L52.9997 44.7573L46.1572 48.1192L52.9978 51.5251Z",
    fill: "#6D0074"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M62.3571 46.8656L69.1344 43.4885L62.3533 40.1611L62.3571 46.8656Z",
    fill: "#6D0044"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M52.9997 20.4751H50.6269L43.6426 31.0187L43.9876 31.2333L52.9978 26.8058V26.4225L53.3428 26.1848L53.3447 20.7741L52.9997 20.4751Z",
    fill: "#FFA80A"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    d: "M52.9978 26.4224L43.6406 31.0185V40.161L52.9997 35.5591L53.3447 35.3483V26.9724L52.9978 26.4224Z",
    fill: "#D7001F"
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    d: "M53 20.4751H55.3728L62.359 31.0187L62.014 31.2333L53.343 26.9726L52.998 26.4225L53 20.4751Z",
    fill: "#FFE50A"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M62.3533 40.1591L53 35.5649V26.4224L62.3572 31.0185L62.3533 40.1591Z",
    fill: "#EF8109"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFetImg19);
export default __webpack_public_path__ + "static/media/fet-img (19).13b015df5f9ffac7192cfdb7dd5ad1cc.svg";
export { ForwardRef as ReactComponent };